import { v4 as uuidV4 } from "uuid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function SelectCategoryFilter({
  categories,
  assetCategory,
  handleAssetCategoryChange,
  isDarkMode,
}) {
  return (
    <FormControl
      sx={{ minWidth: 200, marginTop: ".1em", marginRight: ".4em" }}
      size="large"
    >
      <InputLabel
        id="demo-simple-select-standard-label"
        sx={{ color: isDarkMode && "#FFF" }}
      >
        ---Filter---
      </InputLabel>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        value={assetCategory}
        onChange={handleAssetCategoryChange}
        label="Category"
        sx={{
          color: isDarkMode && "#FFF",
          padding: ".5em",
        }}
      >
        <MenuItem value="All Categories">All Categories</MenuItem>
        {categories.map((category) => (
          <MenuItem key={uuidV4()} value={category}>
            {category}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectCategoryFilter;
